<mat-menu class="popover__menu ignore-click"
          #editMenu="matMenu">
  <ng-template matMenuContent
               let-note="note">
    <button mat-menu-item
            *ngIf="canEdit(note) | async"
            (click)="noteMarkedForEdit=note"
            data-test-id="editNoteButton">Edit
    </button>
    <ng-container *ngIf="targetType !== 'TaggableLogbook'">
      <button mat-menu-item
              *ngIf="canPinNote(note) | async"
              (click)="togglePinned(note)"
              data-test-id="pinNoteButton">{{ isPinned(note) ? 'Unpin note' : 'Pin note' }}
      </button>
    </ng-container>
    <button mat-menu-item
            *ngIf="canRemove(note) | async"
            (click)="removeNote(note)"
            data-test-id="removeNoteButton">
      <span class="drawerNav__link link link--red">Remove</span>
    </button>
    <ng-container *ngIf="viewAllMenuItemVisible">
      <mat-divider></mat-divider>
      <button mat-menu-item
              (click)="onViewAllNotesClicked(note)">
        <span class="drawerNav__link link link">View All Notes</span>
      </button>
    </ng-container>
  </ng-template>
</mat-menu>

<div class="tr tile__heading pt-0 pb-0 tr--baseline tr--noGutter"
     *ngIf="noteMarkedForEdit != note">
  <i
     class="{{ isPinned(note) ? 'far' : 'fal' }} {{ note.isFile ? 'fa-paperclip' : 'fa-sticky-note'}} mr-0050 note-icon"></i>
  <div class="note__date">
    {{note.createdAt|date:'mediumDate'}} • {{ note.createdBy.name }}</div>
  <button class="mat-button--no-ripple mat-button--no-focus-overlay slim p-0050"
          mat-button
          type="button"
          *ngIf="shouldShowNoteMenu(note) | async"
          (click)="menuClick($event)"
          [matMenuTriggerFor]="editMenu"
          [matMenuTriggerData]="{note: note}"
          [attr.data-test-id]="'noteDrawer_' + i">
    <i class="far fa-fw fa-ellipsis-h fa--gray pt-0"></i>
  </button>
</div>
<div class="tr tr--noGutter note__main">
  <!-- Inline edit not active-->

  <ng-container *ngIf="noteMarkedForEdit != note">
    <div class="note__content w-100"
         *ngIf="note.text"
         [ngSwitch]="note.noteType">
      <span *ngSwitchCase="'date'"> {{note.text | date:'shortDate'}}</span>
      <span *ngSwitchCase="'number'">{{note.text | number}}</span>
      <ng-container *ngSwitchDefault>
        <app-clipped-note [text]="note.text"
                          *ngIf="truncateEnabled">
        </app-clipped-note>
        <span *ngIf="!truncateEnabled"
              [innerHTML]="note.text | escapedHtml | autolinker"></span>
      </ng-container>
    </div>
    <div *ngIf="isFile(note)">
      <a class="link link--small link--noline">
        <i class="far fa-arrow-to-bottom mr-0025"></i>
        {{ note.label || note.fileName }}
      </a>
    </div>
  </ng-container>

  <!-- Inline edit is active-->
  <ng-container *ngIf="noteMarkedForEdit == note">
    <app-note-edit class="col__"
                   [targetType]="targetType"
                   [targetId]="targetId"
                   [note]="note"
                   (canceled)="noteMarkedForEdit=null"></app-note-edit>
  </ng-container>
</div>
